/* Blackjack bet template — main bet plus the four side bets */
const data = {
    main: 0,
    perfectPair: 0,
    twentyone: 0,
    crazySeven: 0,
    bustBonus: 0,
}

module.exports = data
